import RateSummaryCard from "./review/RateSummaryCard";
import ConceptsSummary from "./review/ConceptsSummary";
import ConditionsSummary from "./review/ConditionsSummary";
import RateItemsSummary from "./review/RateItemsSummary";

export default function RateReview({
  rate,
  iseditable
}) {

  return (
    <div className="review-layout">

      {/* A — Acuerdo */}
      <RateSummaryCard rate={rate} onEdit={false} editable={iseditable}/>

      {/* B — Conceptos */}
      <ConceptsSummary
        concepts={rate.concepts}
        editable={iseditable}
      />

      {/* C — Condiciones */}
      <ConditionsSummary
        conditions={rate.conditions}
        editable={iseditable}
      />

      {/* D — Reglas */}
      <RateItemsSummary
        items={rate.items}
        concepts={rate.concepts}
        conditions={rate.conditions}
        editable={iseditable}
      />

    </div>
  );
}
